import Clarity from '@microsoft/clarity';

// Wrapper fino sobre @microsoft/clarity. Cada llamada va en try/catch porque Clarity
// puede no estar inicializado (REACT_APP_PUBLIC_ENABLE_TRACKING off) y no debe romper la app.

export const clarityInit = (projectId: string): void => {
  try {
    Clarity.init(projectId);
  } catch {
    // off
  }
};

export const clarityIdentify = (customId: string, friendlyName?: string | null): void => {
  try {
    Clarity.identify(customId, undefined, undefined, friendlyName || undefined);
  } catch {
    // off
  }
};

// Aplica tags de sesión. Solo valores truthy; nunca PII en claro (el facade ya
// reemplaza email por user_hash).
export const claritySetTags = (tags: Record<string, string | number | boolean | null | undefined>): void => {
  try {
    Object.entries(tags).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        Clarity.setTag(key, String(value));
      }
    });
  } catch {
    // off
  }
};

export const clarityEvent = (name: string): void => {
  try {
    Clarity.event(name);
  } catch {
    // off
  }
};

// Prioriza la grabación de la sesión actual (Clarity samplea a 100k/día).
export const clarityUpgrade = (reason: string): void => {
  try {
    Clarity.upgrade(reason);
  } catch {
    // off
  }
};
